import baseScmService from 'services/baseScmService';

const instructorsService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    searchInstructors: build.query({
      query: ({ keyword }) => ({
        method: 'GET',
        url: '/instructors/search/',
        params: { q: keyword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchInstructorsQuery } = instructorsService;

export default instructorsService;
